module.exports = __webpack_public_path__ + "img/5.2e85fee8.jpg";